import React from 'react';
import { OverlayTrigger, Glyphicon, Tooltip } from 'react-bootstrap';
import { uniqueId } from '../helpers';

class InfoIcon extends React.Component {
  tooltip = () => {
    const id = uniqueId();
    return (
      <Tooltip placement={this.props.placement || 'top'} id={id}>
        <div>
          {this.props.children}
        </div>
      </Tooltip>
    )
  }

  render() {
    return (
      <div className="info-icon">
        <OverlayTrigger
          placement={this.props.placement || 'top'}
          overlay={this.tooltip()}
          trigger={['hover', 'focus', 'click']}
          rootClose
        >
          <Glyphicon glyph="info-sign" />
        </OverlayTrigger>
      </div>
    )
  }
}

export default InfoIcon;



// WEBPACK FOOTER //
// ./src/components/InfoIcon.js